module.exports = __webpack_public_path__ + "static/media/FondoLogin.c3bc5c20.png";